<template>
  <Modal
    data-test="modal__error-container"
    class="dea-modal-overlay--error dea-modal--no-footer"
    :visible="visible"
    @modalClose="$emit('close-modal')"
  >
    <template slot="title">Si è verificato un errore</template>
    <template slot="content">
      <p>Ci dispiace, qualcosa è andato storto. Accedi nuovamente a Deascuola.</p>
      <div class="dea-modal__cta">
        <Buttons
          class="dea-button--medium dea-button--right"
          data-test="bsmart-modal--button__logout"
          type="a"
          :href="$root.config.logout_url"
          >Accedi</Buttons
        >
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/patterns/Modal";
import Buttons from "@/components/elements/Buttons";

export default {
  name: "LoadingErrorModal",
  components: { Modal, Buttons },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.dea-modal-overlay--error {
  .dea-modal {
    @include media("<=s") {
      top: 33%;
      width: 90%;
    }
  }

  .dea-modal__close-button {
    display: none;
  }
}

.dea-modal__cta {
  margin-top: $space-small;
  text-align: right;
}
</style>
